<template>
  <section class="custom-wrapper">
    <z-table :model-value="groups" class="table table-bordered table-sm" :columns="tableColumns">
      <template #tbody="props">
        <td>{{ props.row.adasCategory }}</td>
        <td>{{ props.row.system }}</td>
        <td>{{ props.row.location }}</td>
        <td>{{ props.row.matrixModel }}</td>
        <td>{{ yearRange(props.row) }}</td>
        <td>{{ props.row.adasLinks }}</td>
        <td class="text-center">{{ props.row.timesReported }}</td>
      </template>
      <template #detail="props">
        <repair-link-members
          :row="props.row"
          :links="props.row.links"
          :source="source"
          :validations="validations"
          :is-validated="isValidated"
          @edit="$emit('edit', props.row, $event)"
        />
      </template>
      <template #empty> No calibrations found! </template>
    </z-table>
  </section>
</template>
<script>
import { clicksFor } from '@/plugins/broken-link-helper'
import ZTable from '@/components/utilities/elements/Table.vue'
import RepairLinkMembers from '@/components/adasmatrix/repair-link-members.vue'

export default {
  name: 'RepairLinkGroups',
  components: {
    ZTable,
    RepairLinkMembers
  },
  props: {
    groups: {
      type: Array,
      default: () => []
    },
    source: {
      type: String,
      default: ''
    },
    validations: {
      type: Object,
      default: () => ({})
    },
    isValidated: {
      type: Boolean,
      default: false
    }
  },
  emits: ['edit'],
  computed: {
    tableColumns() {
      return [
        { field: 'adasCategory', label: 'Adas Category', sortable: false },
        { field: 'system', label: 'System', sortable: false },
        { field: 'location', label: 'Location', sortable: false },
        { field: 'matrixModel', label: 'Matrix Model', sortable: false },
        { field: 'yearStart', label: 'Matrix Years', sortable: false },
        { field: 'adasLinks', label: 'LinkInfoId', sortable: false },
        { field: 'timesReported', label: 'Clicks', sortable: false }
      ]
    }
  },
  methods: {
    totalClicks(group) {
      return (group.links || []).reduce((total, link) => total + clicksFor(link), 0)
    },
    yearRange(group) {
      if (!group.yearStart && !group.yearEnd) {
        return ''
      }
      if (group.yearStart === group.yearEnd) {
        return `${group.yearStart}`
      }
      return `${group.yearStart} - ${group.yearEnd}`
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  width: 100%;
}
</style>
